/**
 * Font size definitions used throughout the Ardoq design system.
 * Using rem units for accessibility - this allows taking into consideration
 * user's browser settings.
 *
 * @internal These tokens should only be used within the design system.
 * Use the typography components or mixins from `@ardoq/typography` instead.
 */
export const fontSize = {
  small: '0.75rem', // 12px
  regular: '0.875rem', // 14px
  large: '1rem', // 16px
  xlarge: '1.125rem', // 18px
  x2large: '1.25rem', // 20px
  x3large: '1.375rem', // 22px
  x4large: '1.625rem', // 26px
};
